export default __webpack_public_path__ + "static/media/rightgroup.d901a26e.svg";